import { Log } from '@/types/logs'
import { BusAuthorizedStatus, MechanicalInformationRequestBody } from '@/types/mechanicalInformation'
import { getFormattedDate } from '@/helpers/time'
import { FormValuesType } from '../schema'
import { MECHANICAL_INFORMATION_FORM_FIELDS } from '../constant'

export const buildMechanicalInformationRequestBody = ({
    log,
    values,
}: {
    log: Log
    values: FormValuesType
}): MechanicalInformationRequestBody => {
    const requestBody: MechanicalInformationRequestBody = {
        id: log.mechanicalInfo?.id || crypto.randomUUID(),
        tranzauraUsageType: values[MECHANICAL_INFORMATION_FORM_FIELDS.usedTranzaura],
        timeEngineeringContactedDetails: values[MECHANICAL_INFORMATION_FORM_FIELDS.contactTimeDetails],
        engineeringStatement: values[MECHANICAL_INFORMATION_FORM_FIELDS.engineeringStatement],
        busAuthorizedStatus: values[MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus],
        logId: log.id,
    }

    if (requestBody.busAuthorizedStatus === BusAuthorizedStatus.BusAuthorized) {
        const timeCleared = values[MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared]
        if (timeCleared) {
            requestBody.timeCleared = getFormattedDate({ time: values[MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared] })
        } else {
            requestBody.busAuthorizedStatus = undefined
        }
    }

    if (requestBody.busAuthorizedStatus === BusAuthorizedStatus.SubstitutionRequired) {
        const subbedBonnetNumber = values[MECHANICAL_INFORMATION_FORM_FIELDS.bonnetNumber]
        const substitutionTime = values[MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime]

        if (substitutionTime && subbedBonnetNumber) {
            requestBody.subbedBonnetNumber = values[MECHANICAL_INFORMATION_FORM_FIELDS.bonnetNumber]
            requestBody.substitutionTime = getFormattedDate({
                time: values[MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime],
            })
        } else {
            requestBody.busAuthorizedStatus = undefined
        }
    }

    return requestBody
}
